import { Divider, Flex, FlexProps } from "@chakra-ui/react";
import { ReactNode } from "react";

import { OFText } from "design_system/components/OFText";
import { colors } from "src/colors";

import { LABEL_TEXT_STYLE, VALUE_TEXT_STYLE } from "./constant/style";

type Props = FlexProps & {
  label?: string;
  value?: string;
  children?: ReactNode;
};

export const SummaryItem = ({ label, value, children, ...props }: Props) => {
  return (
    <Flex flexDirection="column">
      <Flex justifyContent="space-between" my="12px" {...props}>
        {children || (
          <>
            <OFText textStyle={LABEL_TEXT_STYLE}>{label}</OFText>

            <OFText textStyle={VALUE_TEXT_STYLE}>{value}</OFText>
          </>
        )}
      </Flex>

      <Divider borderColor={colors.grey[300]} />
    </Flex>
  );
};
